import React, { useContext } from "react";
import { NavLink } from "react-router-dom";
import { MakeClassName } from "../../component/global/MakeClassName";
import { GlobalStateContext } from "../../layouts/GlobalStates";
import { isDashboardIndexPath } from "./sidebarNav";
import "./style.scss";

const RightSidebarListItem = ({ item, onClick, newMessagesCompany }) => {
    const { currentPanel } = useContext(GlobalStateContext);

    // NOTE:
    // images in react must be imported through webpack and placing them in public assets is not good practice.

    return (
        <>
            <NavLink
                to={item.addressLink}
                onClick={() => onClick()}
                end={isDashboardIndexPath(item.addressLink)}
                className={({ isActive }) =>
                    MakeClassName("sidebar_list_link ", isActive && "active")
                }
            >
                <li className="sidebar_list_link">
                    <div className="sidebar_list_item">
                        {item.iconName}
                        <span className="sidebar_list_text">{item.title}</span>
                        {item.menuKey === "messages" &&
                            currentPanel === "organ" &&
                            newMessagesCompany !== 0 && (
                                <div className="new-messages-count">
                                    {newMessagesCompany}
                                </div>
                            )}
                    </div>
                </li>
            </NavLink>
        </>
    );
};

export default RightSidebarListItem;
